<template>
  <div
    id="app"
    style="
      position: relative;
      margin: 0 auto;
      max-width: unset;
      width: calc(100 * var(--app-vw));
    "
  >
    <!-- 预加载音频，但不自动播放 -->
    <audio
      id="clockSound"
      :src="require('@/assets/music/clock.mp3')"
      preload="auto"
    ></audio>
    <audio
      id="niaoSound"
      :src="require('@/assets/music/niao.mp3')"
      preload="auto"
    ></audio>
    <audio
      id="niao2Sound"
      :src="require('@/assets/music/niao2.mp3')"
      preload="auto"
    ></audio>

    <img
      id="audioimage"
      :style="{
        width: 'calc(8 * var(--app-vw))',
        position: 'absolute',
        right: 'calc(5 * var(--app-vw))',
        top: 'calc(5 * var(--app-vw))',
        zIndex: '999999',
      }"
      :src="require('@/assets/images/nomusic.png')"
      @click="audioPlayOrPause"
      v-if="!palymusic"
    />
    <img
      id="audioimage"
      :style="{
        width: '8%',
        position: 'absolute',
        right: 'calc(5 * var(--app-vw))',
        top: 'calc(5 * var(--app-vw))',
        zIndex: '999999',
        animation: 'playframes 2s linear infinite',
      }"
      :src="require('@/assets/images/music.png')"
      @click="audioPlayOrPause"
      v-else
    />
    <audio
      id="audioa"
      ref="audio"
      :src="require('@/assets/music/music.mp3')"
      loop
      preload="auto"
      @pause="onPause"
      @play="onPlay"
    ></audio>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      palymusic: false,
    };
  },
  mounted() {
    this.setAppWidthAsCSSVar();
    // this.$nextTick(() => {
    //   this.autoPlayMusic();
    // });
  },
  created() {
    document.title = "艺术，点亮城市的第25小时";
  },
  methods: {
    setAppWidthAsCSSVar() {
      let appElement = document.getElementById("app");
      if (appElement) {
        let width =
          innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
        let height =
          innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight;
        console.log(width / height);

        // 设置屏幕比例，保存至storage中，
        // short < 16/9
        // normal >= 16/9
        // long >= 18/9
        if (height / width <= 16 / 9) {
          localStorage.setItem("ScreenRatio", "short");
        } else if (height / width <= 18 / 9) {
          localStorage.setItem("ScreenRatio", "normal");
        } else {
          localStorage.setItem("ScreenRatio", "long");
        }

        if (width / height > 0.75) {
          appElement.style["width"] = "56.25vh";
          appElement.style["max-width"] = "56.25vh";
        } else {
          appElement.style["width"] = "unset";
          appElement.style["max-width"] = "unset";
        }
        let appWidth = appElement.clientWidth / 100; // 获取 #app 的宽度
        document.documentElement.style.setProperty("--app-vw", appWidth + "px");
      }
    },

    audioPlayOrPause() {
      this.palymusic = !this.palymusic;
      if (!this.palymusic) {
        this.audioPause();
      } else {
        this.audioAutoPlay();
      }
    },
    onPause() {
      this.palymusic = false;
    },
    onPlay() {
      this.palymusic = true;
    },
    audioPause() {
      let audio = this.$refs.audio;
      audio.pause();
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          console.log("WeixinJSBridgeReady pause");
          audio.pause();
        },
        { once: true }
      );
    },
    audioAutoPlay() {
      let audio = this.$refs.audio;
      audio.play();
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          console.log("WeixinJSBridgeReady play");
          audio.play();
        },
        { once: true }
      );
    },

    /** 微信 H5 自动播放：三路并发策略 */
    autoPlayMusic() {
      const audio = this.$refs.audio;
      if (!audio) return;

      let played = false; // 防重入锁：三路策略谁先成功，另外两路不再执行
      const play = () => {
        if (played) return;
        // 如果音频已在播放（比如被 audioAutoPlay 先行启动），不再重复 play
        if (!audio.paused) {
          played = true;
          return;
        }
        played = true;
        const promise = audio.play();
        if (promise !== undefined) {
          promise
            .then(() => {})
            .catch(() => {
              // play 被拦截（如 iOS 无用户手势），放锁让交互兜底重试
              played = false;
            });
        }
      };

      // 1. WeixinJSBridge — Android 微信桥接就绪后立即播放
      if (
        window.WeixinJSBridge &&
        typeof window.WeixinJSBridge.invoke === "function"
      ) {
        play();
      } else {
        document.addEventListener("WeixinJSBridgeReady", play, { once: true });
      }

      // 2. wx.ready — 微信 JSSDK 配置完成后尝试（iOS 可能被拦截）
      if (window.wx) {
        try {
          window.wx.ready(play);
        } catch (e) {
          /* ignore */
        }
      }

      // 3. 用户交互兜底 — iOS 必须有点击/触摸才能播放
      //    只绑 click 不绑 touchstart，避免 touchstart 先触发导致与 @click 冲突
      document.addEventListener("click", play, { once: true });
    },
  },
};
</script>

<style>
body {
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-text-size-adjust: 100% !important;
}

* {
  margin: 0px;
  padding: 0px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: calc(4 * var(--app-vw));
  font-weight: normal;
}

img {
  image-rendering: -moz-crisp-edges; /* Firefox */
  image-rendering: -o-crisp-edges; /* Opera */
  image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
}

/* @font-face {
  font-family: "lsjgyzyt";
  src: url("./assets/font/SourceHanSerifCN-Medium.otf");
  font-weight: normal;
  font-style: normal;
}

.font {
  font-family: "lsjgyzyt";
  align-items: baseline;
  text-align: justify;
}

.nowrap {
  display: flex;
  align-items: baseline;
  white-space: nowrap;
}

.bold{
  font-weight: bold;
}

.primary{
  color: #df5a59;
}


*/

.bgImg {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  image-rendering: -webkit-optimize-contrast;
  position: absolute;
  padding: 0px;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
}

.dl-flex {
  display: flex !important;
  flex-direction: row !important;
  justify-content: flex-start !important;
  align-items: center !important;
}

.dl-center {
  display: flex !important;
  flex-direction: column;
  align-items: center !important;
  justify-content: center !important;
}

.dl-aligncenter {
  display: flex !important;
  flex-direction: column;
  align-items: center !important;
}

.dl-justifycenter {
  display: flex !important;
  flex-direction: column;
  justify-content: center !important;
}

.dl-line-1 {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dl-line-2 {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical !important;
}
.dl-line-3 {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical !important;
}
.dl-line-4 {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical !important;
}
.dl-line-5 {
  display: -webkit-box !important;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical !important;
}

@keyframes playframes {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1turn);
  }
}

.scaleinsmallbig {
  -webkit-transform: scale(0) translate3d(0, 0, 0);
  transform: scale(0) translate3d(0, 0, 0);
  opacity: 1;
  animation: scale-in-center, smallbig alternate;
  animation-duration: 0.5s, 1.5s;
  animation-timing-function: linear, linear;
  animation-iteration-count: 1, infinite;
  animation-delay: 0s, 0.5s;
}

.sleepsmallbig {
  -webkit-transform: scale(0) translate3d(0, 0, 0);
  transform: scale(0) translate3d(0, 0, 0);
  opacity: 1;
  animation: smallbig 1.5s linear infinite 0.5s;
}

.scalein {
  -webkit-transform: scale(0) translate3d(0, 0, 0);
  transform: scale(0) translate3d(0, 0, 0);
  opacity: 1;
  animation: scale-in-center;
  animation-duration: 0.5s;
  animation-timing-function: linear;
  animation-iteration-count: 1;
  animation-delay: 0s;
  animation-fill-mode: forwards;
}

@keyframes smallbig {
  0%,
  100% {
    transform: scale(1) translate3d(0, 0, 0);
  }
  50% {
    transform: scale(1.1) translate3d(0, 0, 0);
  }
}

@-webkit-keyframes scale-in-center {
  0% {
    -webkit-transform: scale(0) translate3d(0, 0, 0);
    transform: scale(0) translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1) translate3d(0, 0, 0);
    transform: scale(1) translate3d(0, 0, 0);
    opacity: 1;
  }
}
@keyframes scale-in-center {
  0% {
    -webkit-transform: scale(0) translate3d(0, 0, 0);
    transform: scale(0) translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1) translate3d(0, 0, 0);
    transform: scale(1) translate3d(0, 0, 0);
    opacity: 1;
  }
}

@-webkit-keyframes opacityinframes {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes opacityinframes {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.opacityin {
  -webkit-transform: opacity(0) translate3d(0, 0, 0);
  transform: opacity(0) translate3d(0, 0, 0);
  animation: opacityinframes;
  animation-duration: 0.5s;
  animation-timing-function: ease;
  animation-iteration-count: 1;
  animation-delay: 0s;
  animation-fill-mode: forwards;
}

.opacityin1 {
  -webkit-transform: opacity(0) translate3d(0, 0, 0);
  transform: opacity(0) translate3d(0, 0, 0);
  animation: opacityinframes;
  animation-duration: 1s;
  animation-timing-function: ease;
  animation-iteration-count: 1;
  animation-delay: 0s;
  animation-fill-mode: forwards;
}

.opacityin2 {
  -webkit-transform: opacity(0) translate3d(0, 0, 0);
  transform: opacity(0) translate3d(0, 0, 0);
  animation: opacityinframes;
  animation-duration: 2s;
  animation-timing-function: ease;
  animation-iteration-count: 1;
  animation-delay: 0s;
  animation-fill-mode: forwards;
}

.opacityin3 {
  -webkit-transform: opacity(0) translate3d(0, 0, 0);
  transform: opacity(0) translate3d(0, 0, 0);
  animation: opacityinframes;
  animation-duration: 3s;
  animation-timing-function: ease;
  animation-iteration-count: 1;
  animation-delay: 0s;
  animation-fill-mode: forwards;
}

.opacityin5 {
  -webkit-transform: opacity(0) translate3d(0, 0, 0);
  transform: opacity(0) translate3d(0, 0, 0);
  animation: opacityinframes;
  animation-duration: 5s;
  animation-timing-function: ease;
  animation-iteration-count: 1;
  animation-delay: 0s;
  animation-fill-mode: forwards;
}

@-webkit-keyframes opacityoutframes {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes opacityoutframes {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.opacityout {
  -webkit-transform: opacity(0) translate3d(0, 0, 0);
  transform: opacity(0) translate3d(0, 0, 0);
  animation: opacityoutframes;
  animation-duration: 1s;
  animation-timing-function: ease;
  animation-iteration-count: 1;
  animation-delay: 0s;
  animation-fill-mode: forwards;
}

.hiddenscroll::-webkit-scrollbar {
  display: none;
}

@keyframes float-move {
  0% {
    left: 16rem;
    bottom: 26rem;
    transform: rotate(7deg);
  }
  /* ✅ 99.9% 仍保持结束状态，避免提前开始回弹 */
  99.9% {
    left: 18rem;
    bottom: 24rem;
    transform: rotate(13deg);
  }
  100% {
    left: 18rem;
    bottom: 24rem;
    transform: rotate(13deg);
  }
}

.animated-element {
  position: absolute;
  /* 🎯 去掉 alternate，使用 linear 保证全程匀速直到最后一帧才跳变 */
  animation: float-move 1s linear infinite;
}
</style>



// WEBPACK FOOTER //
// src/App.vue